import { formatDoorNumber } from '@/lib/door-helpers';

/**
 * Gibt das anzuzeigende Tür-Label zurück.
 *
 * door_number ist die physische Nummer, die auf der Tür steht (von Monteuren vor Ort gelesen).
 * Sie ist seit dem Rückbau von doors.door_id das einzige User-sichtbare Türnummer-Feld.
 */
export function getDoorLabel(door: {
  door_number?: string | null;
}): string {
  const number = door.door_number?.trim();
  if (number) {
    return formatDoorNumber(number);
  }
  return '';
}
